import React, { useRef } from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";

import IconButton from "shared/react_components/IconButton";
import DebouncedInput from "shared/react_components/DebouncedInput";
import MaterialIcon from "shared/react_components/MaterialIcon";
import PointerEvents from "stylesheets/utilities/pointerEvents.module.scss";

import { transcriptSearchInput, searchCounts, searchIcon, searchHelpInfo } from "./styles/TranscriptSearch.module.scss";

const MAX_CHAR_LIMIT = 2000;

const TranscriptSearch = ({ className, onSearchTextChange, onSearchFocusChange, onActiveSearchIndexIncrement, activeIndex, searchMatchTotal }) => {
  const advancedSearchOptionsRef = useRef();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onActiveSearchIndexIncrement(event.shiftKey ? -1 : 1);
    }
  };

  const onFocus = () => {
    onSearchFocusChange && onSearchFocusChange(true);
  };

  const onBlur = () => {
    onSearchFocusChange && onSearchFocusChange(false);
  };

  return (
    <div className={className}>
      <div className="d-flex align-items-center">
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <InputGroupText className={searchIcon}>
              <MaterialIcon name="search"/>
            </InputGroupText>
          </InputGroupAddon>

          <DebouncedInput placeholder="Search" className={transcriptSearchInput} onChange={onSearchTextChange}
            onKeyPress={handleKeyPress} type="search" onBlur={onBlur} onFocus={onFocus} maxLength={MAX_CHAR_LIMIT}
          />

          <InputGroupAddon addonType="append">
            <InputGroupText className={searchCounts} data-test-id="search-counts">
              {searchMatchTotal > 0 ? activeIndex + 1 : 0}/{searchMatchTotal}
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>

        <span>
          <IconButton icon="keyboard_arrow_left" onClick={() => onActiveSearchIndexIncrement(-1)}
            tooltipText="Previous" tooltipPlacement="bottom" onBlur={onBlur} onFocus={onFocus}
          />
        </span>

        <span>
          <IconButton icon="keyboard_arrow_right" onClick={() => onActiveSearchIndexIncrement(1)}
            tooltipText="Next" tooltipPlacement="bottom" onBlur={onBlur} onFocus={onFocus}
          />
        </span>
      </div>

      <span className={searchHelpInfo} ref={advancedSearchOptionsRef} data-test-id="advanced-search-info">
        Advanced search options
      </span>
      <UncontrolledTooltip className={PointerEvents.none} target={advancedSearchOptionsRef}
        trigger="hover" placement="bottom"
      >
        {'Use quotes to search for multi-word phrases (e.g. "appointment made")'}
      </UncontrolledTooltip>
    </div>
  );
};

TranscriptSearch.propTypes = {
  className: PropTypes.string,
  onSearchTextChange: PropTypes.func,
  onActiveSearchIndexIncrement: PropTypes.func,
  activeIndex: PropTypes.number,
  searchMatchTotal: PropTypes.number,
  onSearchFocusChange: PropTypes.func
};

TranscriptSearch.defaultProps = {
  className: "",
  onActiveSearchIndexIncrement: () => {},
  searchMatchTotal: 0
};

export default TranscriptSearch;
